import React, { useState, useEffect } from 'react';
import pb from '../../lib/pocketbase';
import BookingConfigurator from '../../components/BookingConfigurator/BookingConfigurator';
import './Home.css';

const Home = (props) => {
    const { dbServices, setCurrentPage, agencySettings } = props;
    const [stats, setStats] = useState({ keys: 1250, ethanol: 840, diag: 3100 });

    const companyName = agencySettings?.company_name || "Ma clé 31";
    const slogan = agencySettings?.slogan || "Atelier de reprogrammation automobile à Toulouse";
    const description = agencySettings?.description || `Gardez votre véhicule en parfait état de fonctionnement avec ${companyName} dans la Haute-Garonne.`;

    const logoUrl = agencySettings ? (
        agencySettings.logo_light ? pb.files.getUrl(agencySettings, agencySettings.logo_light) : '/logo.png'
    ) : '/logo.png';

    useEffect(() => {
// ... (omitted)
        const fetchStats = async () => {
            try {
                const [appts, users, invoices] = await Promise.all([
                    pb.collection('appointments').getList(1, 1),
                    pb.collection('users').getList(1, 1),
                    pb.collection('invoices').getList(1, 1)
                ]);
                setStats({
                    keys: 850 + (appts.totalItems * 2),
                    ethanol: 420 + Math.floor(invoices.totalItems / 2),
                    diag: 2100 + (users.totalItems * 3)
                });
            } catch (e) { /* Keep defaults */ }
        };
        fetchStats();
    }, []);

    const categories = [
        { id: 'Clés', label: 'Reproduction de clés', icon: '🔑', desc: 'Perte ou double de vos clés' },
        { id: 'Éthanol', label: 'Passage à l’Éthanol', icon: '⛽', desc: 'Économisez sur chaque plein' },
        { id: 'Diagnostic', label: 'Diagnostic Auto', icon: '💻', desc: 'Recherche de panne moteur' },
        { id: 'Moteur', label: 'Ingénierie Moteur', icon: '⚙️', desc: 'Performance et optimisation' },
    ];

    return (
        <div className="home-container">
            <BookingConfigurator {...props} />

            <section className="intro-card" style={{ marginTop: '2rem' }}>
                <div className="intro-content">
                    <div className="intro-text">
                        <h2>{slogan}</h2>
                        <p>{description}</p>
                        <p>
                            {companyName} est un atelier spécialisé dans la mécanique et l&apos;ingénierie
                            automobile. Nous intervenons en urgence pour la reproduction des clés, la reprogrammation du
                            moteur à l&apos;éthanol et le diagnostic électronique.
                        </p>
                    </div>
                    <div className="intro-logo-container">
                        <img src={logoUrl} alt={`${companyName} Logo`} className="floating-logo" />
                    </div>
                </div>
            </section>

            {/* CATALOGUE DE SOLUTIONS */}
            <section className="h-tech-catalog gold-theme">
                <div className="section-title-tech gold">
                    <span className="title-text-tech">Solutions & Tarifs</span>
                    <div className="title-line gold"></div>
                </div>
                <div className="tech-grid">
                    {categories.map(cat => {
                        return (
                            <div key={cat.id} className="tech-card gold">
                                <div className="tech-card-icon gold">{cat.icon}</div>
                                <h3>{cat.label}</h3>
                                <p>{cat.desc}</p>
                                <button className="hero-cta small gold" onClick={() => setCurrentPage(cat.id.toLowerCase().replace('é', 'e'))}>En savoir plus</button>
                            </div>
                        );
                    })}
                </div>
            </section>

            <section className="hero-image-container">
                <img
                    src="https://images.unsplash.com/photo-1487754180451-c456f719a1fc?q=80&w=2070&auto=format&fit=crop"
                    alt="Atelier automobile moderne"
                    className="hero-image"
                />
            </section>

            <section className="info-grid">
                <article className="info-card clickable" onClick={() => setCurrentPage('cles')}>
                    <div className="card-image">
                        <img src="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?q=80&w=2070&auto=format&fit=crop" alt="Reproduction de clés de précision" />
                    </div>
                    <h3>Reproduction de clés de voitures</h3>
                    <p>
                        Clés manuelles ou électroniques, nous reproduisons une clé identique à l&apos;originale avec un
                        service rapide et soigné.
                    </p>
                </article>
                <article className="info-card clickable" onClick={() => setCurrentPage('ethanol')}>
                    <div className="card-image">
                        <img src="https://images.unsplash.com/photo-1619682817481-e994891cd1f5?q=80&w=2400&auto=format&fit=crop" alt="Moteur voiture" />
                    </div>
                    <h3>Reprogrammation éthanol</h3>
                    <p>
                        Conversion E85, optimisation de la cartographie moteur et économies de carburant tout en
                        préservant la longévité du moteur.
                    </p>
                </article>
                <article className="info-card clickable" onClick={() => setCurrentPage('diagnostic')}>
                    <div className="card-image">
                        <img src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2600&auto=format&fit=crop" alt="Diagnostic électronique" />
                    </div>
                    <h3>Diagnostic électronique</h3>
                    <p>
                        Lecture des codes défaut, détection de pannes et contrôle complet des systèmes électroniques
                        de ton véhicule.
                    </p>
                </article>
            </section>

            <section className="info-grid">
                <article className="info-card">
                    <h3>{companyName}, votre atelier automobile de confiance</h3>
                    <p>
                        Mécaniciens professionnels, nous garantissons un service réactif et efficace pour répondre à
                        tous vos besoins : reproduction de clés, reprogrammation éthanol, diagnostic électronique.
                    </p>
                    <p className="summary-title">Pourquoi choisir {companyName} ?</p>
                    <ul>
                        <li>Conseil</li>
                        <li>Rapidité d&apos;intervention</li>
                        <li>Travail de qualité</li>
                        <li>Disponibilité</li>
                    </ul>
                </article>
                <article className="info-card">
                    <h3>Notre zone de déplacement</h3>
                    <p>
                        Nous nous déplaçons dans un rayon de 100 km autour de Toulouse : Balma, Labège, L&apos;Union,
                        Villefranche-de-Lauragais, Auterive, Muret, Cazères, Carbonne, Saint-Gaudens, Blagnac,
                        Colomiers, Aucamville, Bruguières, Fronton...
                    </p>
                    <div className="map-container" style={{ height: '300px', width: '100%', borderRadius: '0 0 2rem 2rem', overflow: 'hidden' }}>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d115456.843231307!2d1.4442!3d43.6047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sfr!4v1714578120000!5m2!1sfr!2sfr"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title={`Zone d'intervention ${companyName}`}
                        ></iframe>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default Home;
